'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'page';

var getSection = function getSection(section) {
  if (section) {
    return _react2.default.createElement(
      'h2',
      {
        className: CLASS_NAME + '-section-title'
      },
      section
    );
  }

  return null;
};

exports.default = getSection;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Page/utils/getSection.js
// module id = 1107
// module chunks = 0